export default "__VITE_ASSET__CE8J1sLV__"